import React, { Component } from 'react'
import { render } from 'react-dom'
import { createUrl } from '../../common/utils'
import  Buy, { TipPop }  from './Components'

class Demo extends React.Component {
    constructor(props) {
        super(props)        
    }

    state = {
        pop: null,
        msg: ''
    }

    popTip = (msg) => {
        this.setState({
            pop: 'tip',
            msg
        })
    }

    updatePopData = (data) => {
        this.setState(data)
    }

    onClose = () => {
        this.setState({pop: null})
    }

    render() {
        const { pop, msg } = this.state

        return (
            <div className="act-main">                                                
                <div className="banner">
                    <div className="banner-product1"></div>
                    <div className="banner-product2"></div>
                    <div className="hf-box">
                    <Buy type="pcBtn1" popTip={this.popTip} updatePopData={this.updatePopData} />
                        <div className="hf-txt">
                            <div className="row2">本活动限新办理或升级至129元/月及以上<br />福建电信融合套餐用户参与</div>
                        </div>
                    </div>
                </div>                                
                <div className="section section-gift">
                    <div className="container">
                        <div className="song"></div>
                        <ul className="price-gift">
                            <li>
                                <i>1</i>
                                <p><b>价值<span className="larger">150</span>元</b></p>
                                <p>玩客云特权码（免预约、立即购买）</p>
                            </li>
                            <li>
                                <i>2</i>
                                <p><b>价值<span className="larger">240</span>元</b></p>
                                <p>上行首年0元提速至20M</p>
                            </li>
                            <li>
                                <i>3</i>
                                <p><b>价值<span className="larger">90</span>元</b></p>
                                <p>3个月迅雷超级会员卡</p>
                            </li>
                        </ul>
                        <div className="img-box img-box-song">
                            <img src="/images/onecloud/fjupspeed/pc/ewm2.png" />
                            <p>了解更多融合套餐<br />请扫码或前往福建电信<br />各指定营业网点咨询办理</p>
                        </div>
                    </div>
                </div>            
                <div className="section">
                    <div className="container">
                        <div className="hf-txt">- 上行大提速  享受畅快生活 -</div>
                        <div className="process-box">
                            <div className="process-box-inset">
                                <div className="process-row clear">
                                    <div className="process-col">
                                        <div className="process-col-box">
                                            <i className="icon-process icon-process1"></i>
                                            <h3>上传文件 更迅速</h3>
                                            <p>轻松应对大文件上传<br />传输文件不等待</p>
                                        </div>
                                    </div>
                                    <div className="process-col">
                                        <div className="process-col-box">
                                            <i className="icon-process icon-process2"></i>
                                            <h3>网络游戏 更稳定</h3>
                                            <p>降低网络延迟<br />拒绝中途掉线</p>
                                        </div>
                                    </div>
                                    <div className="process-col">
                                        <div className="process-col-box">
                                            <i className="icon-process icon-process3"></i>
                                            <h3>视频通话 更畅快</h3>
                                            <p>流畅对话清晰视频<br />告别断断续续</p>
                                        </div>
                                    </div>
                                    <div className="process-col">
                                        <div className="process-col-box">
                                            <i className="icon-process icon-process4"></i>
                                            <h3>网络直播 更清晰</h3>
                                            <p>选择更高直播码率<br />直播画面更超清</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section">
                    <div className="container">
                        <div className="hf-txt">- 3步轻松完成提速 - </div>
                        <div className="process-box">
                            <div className="process-box-inset">
                                <div className="step-row clear">
                                    <div className="step-col">
                                        <i className="icon-step icon-step3"></i>
                                        <h3>福建电信融合套餐用户</h3>
                                        <p>● 如您是新用户，请前往福建电信指定营业厅办理指定融合套餐，即可获赠价值480元玩客礼包。</p>
                                        <p>● 如您是129元/月及以上融合套餐用户，请前往福建电信指定营业厅或登录福建电信微信公众号获取480元玩客礼包。</p>
                                    </div>
                                    <div className="step-col">
                                        <i className="icon-step icon-step2"></i>
                                        <h3>购买玩客云福建电信专享版</h3>
                                        <p>● 用融合套餐中手机号登录玩客云官网，直接购买“玩客云福建电信专享版”，无需预约和抢购，还可享受150元优惠。</p>
                                    </div>
                                    <div className="step-col">
                                        <i className="icon-step icon-step1"></i>
                                        <h3>上行首年0元提速至20M</h3>
                                        <p>● 使用融合套餐中的手机号登录“玩客云App”并绑定通过特权码购买的玩客云，将自动获得上行首年0元提速至20M。</p>
                                    </div>
                                </div>
                                <div className="btn-box">
                                <Buy type="pcBtn1" popTip={this.popTip} updatePopData={this.updatePopData} />                                            
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section section-cloud">
                    <div className="container">
                        <h2 className="title2">- 玩客云 畅快下载的私人云盘 -</h2>
                        <div className="onecloud-process">
                            <span>隐私加密</span>
                            <span>远程下载</span>
                            <span>手机扩容</span>
                            <span>多屏互动</span>
                            {/* <span>玩客计划</span> */}
                        </div>
                        <div className="photo-onecloud"></div>
                        <div className="btn-box">
                            <Buy type="pcBtn1" popTip={this.popTip} updatePopData={this.updatePopData} />                                     
                        </div>
                    </div>
                </div>
                <div className="section">
                    <div className="container">
                        <h2 className="title2">- 活 / 动 / 规 / 则 -</h2>
                        <ul className="rule">
                            <li><b>1、玩客礼包：</b></li>
                            <li>新办理或升级至129元/月及以上福建电信融合套餐用户，可获赠价值480元玩客礼包（包含：玩客云特权码x1、上行首年0元提速至20M、3个月迅雷超级会员卡x1）。</li>
                            <li><b>2、活动时间：</b></li>
                            <li>2018年4月23日-2018年10月22日</li>
                            <li><b>3、活动参与方式：</b></li>
                            <li>● 如您是新用户，请前往福建电信指定营业厅办理指定融合套餐，即可获赠价值480元玩客礼包。</li>
                            <li>● 如您是129元/月及以上融合套餐用户，请前往福建电信指定营业厅或登录福建电信微信公众号获取480元玩客礼包。</li>                            
                            <li><b>4、关于“玩客云特权码”：</b></li>
                            <li>使用“特权码”可在官网直接购买玩客云，无需预约和抢购，还可享受150元优惠。</li>
                            <li>● “特权码”发放：“特权码”会自动与办理融合套餐的手机号进行绑定。</li>
                            <li>● “特权码”使用：使用融合套餐中的手机号登录玩客云官网，即可直接购买“玩客云福建电信专享版”。</li>
                            <li>● “特权码”有效期：自用户获得“特权码”之日起的30日内有效，请获得后尽快使用，逾期失效。</li>
                            <li>● “特权码”支付时效：请留意您的订单支付时效，订单生成后即进入24小时支付倒计时，没有在支付时效内成功支付的订单，系统将视为您自动放弃，“特权码”将自动失效并取消订单。</li>
                            <li>● 玩客云发货时间：将在您购买成功后3个工作日内安排发出，具体物流信息请查看订单详情。受客观物流因素影响，可能会有部分延迟，请您耐心等待。</li>
                            <li><b>5、关于“玩客云福建电信专享版”：</b></li>
                            <li>● 可选颜色：目前可购买的“玩客云福建电信专享版”颜色仅为科技蓝。</li>
                            <li>● 使用提示：<span className="yellow">仅可在福建地区使用</span>。</li>
                            <li><b>6、关于“上行首年0元提速至20M”</b></li>
                            <li>● 如何获得提速：使用融合套餐中的手机号登录“玩客云App”并绑定通过特权码购买的玩客云，将自动获得上行首年0元提速至20M。</li>
                            <li><b>7、关于“迅雷超级会员”的发放和使用</b></li>
                            <li>● 使用融合套餐中的手机号登录玩客云官网购买玩客云，付款成功后将获得“3个月迅雷超级会员卡”x1。</li>
                            <li>● “迅雷超级会员”是虚拟奖品，会以卡密的形式通过短信发送至融合套餐手机号，用户可通过卡密在迅雷会员官网进行激活使用。</li>
                            <li><b>* 温馨提示：</b></li>
                            <li>● 若用户在购买“玩客云福建电信专享版”后，自收到商品之日起7日内，非质量原因主动发起退货退款，将退还实际支付金额，成功退款后玩客云特权码将会失效。</li>
                            <li>● 若用户购买“玩客云福建电信专享版”后，非质量原因主动发起退货退款，则赠送的“3个月迅雷超级会员卡”将自动失效，已激活的会员卡将停止服务，“上行首年0元提速至20M”将自动停止服务。</li>
                            <li>● 如有任何疑问请拨打400-109-8880还可访问服务页联系QQ在线客服，服务时间 09:00-21:00。</li>

                        </ul>
                    </div>
                </div>

                <div className="sidebar">
                    <div className="sidebar-title">提速<br />3部曲</div>
                    <div className="step-box">
                        <div className="step-list">
                            <b>Step1</b>
                            <span>福建电信融合套餐用户</span>
                        </div>
                        <div className="step-list">
                            <b>Step2</b>
                            <span>购买玩客云福建电信专享版</span>
                        </div>
                        <div className="step-list">
                            <b>Step3</b>
                            <span>上行首年0元提速至20M</span>
                        </div>
                    </div>
                    <div className="img-box">
                        <img src="/images/onecloud/fjupspeed/pc/ewm.png" />
                        <p>融合老用户上行<br />提速线上办理入口</p>
                    </div>
                </div>
                {pop === 'unused' 
                    && <TipPop 
                            msg="您已获得<br />福建电信专享版特权码" 
                            url={`${createUrl('html/purchase')}?type=tqcode&channel=1`} 
                            btn="前往购买" 
                            onClose={this.onClose} 
                        />
                }
                {pop === 'used' 
                    && <TipPop                                                        
                            msg="您已使用<br />福建电信专享版特权码" 
                            url={`${createUrl('html/usercenter')}`} 
                            btn="查看订单" 
                            onClose={this.onClose} 
                        />
                }
                {pop === 'overdue' 
                    && <TipPop                             
                            msg="您的福建电信专享版特权码已过期"                             
                            btn="确定"                             
                            onClose={this.onClose} 
                        />
                }
                {pop === 'noPriority' 
                    && <TipPop                             
                            msg="您还未获得<br />福建电信专享版特权码"                             
                            btn="确定"                             
                            onClose={this.onClose} 
                        />
                }
                {pop === 'tip' 
                    && <TipPop                             
                            msg={msg}                             
                            btn="确定"                             
                            onClose={this.onClose} 
                        />
                }
            </div>
        )
    }  
}

render(<Demo />, document.getElementById('content'))


// WEBPACK FOOTER //
// ./js/src/pages/FjUpSpeed_pc/index.js